import debug from 'bows/dist/bows.min.js';
const log = debug("offscreen-menu");

const body = document.body;
const offscreenBtnOpen = document.querySelector('.header__menu-open');
const offscreenBtnClose = document.querySelector('.header__menu-close');
const offscreenMenu = document.querySelector('.menu-offscreen');
const offscreenMenuToggle = document.querySelectorAll('.menu-offscreen__nav-toggler');
const offscreenMenuReturn = document.querySelectorAll('.menu-offscreen__return');
const findMenus = document.querySelectorAll('.menu-offscreen__nav');
const offscreenMenuReturnLevel = document.querySelectorAll('.menu-offscreen__return-level');

function esc() {
	document.addEventListener("keydown", function (evt) {
		evt = evt || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = evt.key == "Escape" || evt.key == "Esc";
		} else {
			isEscape = evt.keyCode == 27;
		}

		if (isEscape && body.classList.contains('offscreen-open') === true) {
			closeOffscreen();
		}
	});
}

function openOffscreen() {
	body.classList.add('offscreen-open');
	offscreenMenu.classList.add('menu-offscreen--open');
	setTimeout(() => {
		// let firstItem = offscreenMenu.querySelector('a');
		// firstItem.focus();
	}, 500);
}

function closeOffscreen() {
	body.classList.remove('offscreen-open');
	offscreenMenu.classList.remove('menu-offscreen--open');
}

function returnMain() {
	for (var i = 0; i < findMenus.length; i++) {
		findMenus[i].classList.remove('menu-offscreen__nav--open');
	}
	body.classList.remove('offscreen-levels-open');
	body.classList.remove('offscreen--level-1');
	body.classList.remove('offscreen--level-2');
}

function returnLevel() {
	this.parentNode.parentNode.classList.remove('menu-offscreen__nav--open');
	body.classList.remove('offscreen--level-2');
}

function openSub() {

	let navItem = this.closest('.nav__menu-item');
	let nextSubmenu = navItem.querySelector('.menu-offscreen__nav');

	let cName = nextSubmenu.className.split(' ');
	let level = cName[1].split('--')[1];

	body.classList.add('offscreen-levels-open');
	body.classList.add('offscreen--' + level);
	this.classList.add('menu-offscreen__nav-toggler--open');
	nextSubmenu.classList.add('menu-offscreen__nav--open');

}

export function init() {
	if (offscreenBtnOpen) {
		offscreenBtnOpen.addEventListener('click', openOffscreen);
		esc();
	}
	if (offscreenBtnClose) {
		offscreenBtnClose.addEventListener('click', closeOffscreen);
		esc();
	}
	if (offscreenMenuToggle) {
		offscreenMenuToggle.forEach((osmt) => {
			osmt.addEventListener('click', openSub);
		});
	}

	if (offscreenMenuReturn) {
		offscreenMenuReturn.forEach((osmr) => {
			osmr.addEventListener('click', returnMain);
		});
	}

	if (offscreenMenuReturnLevel) {
		offscreenMenuReturnLevel.forEach((osmrl) => {
			osmrl.addEventListener('click', returnLevel);
		});
	}

}
export default {
	init
};
